module.exports = __webpack_public_path__ + "static/media/award-badge.99b154de.png";